import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withRights } from '../../../../providers/RightsConsumer';
import { TableCell, TableRow, Checkbox, Switch } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';

class OfferDecisionSubsequentConditionItem extends PureComponent {
  handleActiveSelectionChange = event => {
    this.props.onPropertyChange(event.target.name, event.target.checked);
    this.props.onPropertyChange('dueDate', null);
    this.props.onPropertyChange('activationDate', null);
    this.props.onPropertyChange('done', false);
  };

  handleSelectionChange = event => {
    this.props.onPropertyChange(event.target.name, event.target.checked);
  };

  handleTextFieldChange = value => {
    this.props.onPropertyChange(event.target.name, value);
  };

  render() {
    const { condition, rights, isDirty, t } = this.props;
    const estimatedDays = condition.estimatedDays ? `${condition.estimatedDays} ${t('OfferEdit.Decision.SubsequentCondition.Days')}` : '';
    const dueDate = condition.dueDate
      ? `${t('OfferEdit.Decision.SubsequentCondition.Expires')} ${t('DATE', { date: condition.dueDate })}`
      : '';
    const isItemEditable = condition.active ? (condition.done ? isDirty : true) : false;

    const isActiveEditable = condition.done ? isDirty : true;

    return (
      <TableRow>
        <TableCell>
          <Checkbox
            name={'active'}
            checked={condition.active}
            onChange={this.handleActiveSelectionChange}
            disabled={rights.readOnlyFull || !isActiveEditable || !rights.decisionSubsequentConditionsWrite}
          />
        </TableCell>
        <TableCell>{condition.code}</TableCell>
        <TableCell>{condition.text}</TableCell>
        <TableCell>{condition.user}</TableCell>
        <TableCell>
          {condition.active ? (
            <Fragment>
              <div>{estimatedDays}</div>
              <div>{dueDate}</div>
            </Fragment>
          ) : (
            ''
          )}
        </TableCell>
        <TableCell>{condition.active ? t('DATE', { date: condition.activationDate }) : ''}</TableCell>
        <TableCell>
          <Switch
            name={'done'}
            checked={condition.done}
            onChange={this.handleSelectionChange}
            disabled={rights.readOnlyFull || !isItemEditable || !rights.decisionSubsequentConditionsWrite}
          />
        </TableCell>
        <TableCell>
          <TextField
            fullWidth
            name={'comment'}
            value={condition.comment || ''}
            onChange={this.handleTextFieldChange}
            disabled={!condition.active || !isItemEditable || !rights.decisionSubsequentConditionsWrite}
          />
        </TableCell>
      </TableRow>
    );
  }
}

OfferDecisionSubsequentConditionItem.propTypes = {
  onPropertyChange: PropTypes.func.isRequired,
  condition: PropTypes.object.isRequired,
  isDirty: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired
};

export default withTranslation()(withRights(OfferDecisionSubsequentConditionItem));
